import { getFromStorage, LOCAL_STORAGE_ALGOLIA_QUERY_INFO, removeFromStorage, setInStorage } from '@repo/storage/service'

// A query should not be related to follow-up events indefinitely.
const TTL: Readonly<number> = 30 * 60 * 1000 // 30 min.

interface AlgoliaQueryInfo {
  queryID: string
  objectID: string
  timestamp: number
}

export const saveAlgoliaQueryInfo = (queryID: string, objectIDs: string[]): void => {
  const timestamp = Date.now()
  const existing = getAllValidQueryInfos()

  const newEntries: AlgoliaQueryInfo[] = objectIDs.map((objectID) => ({
    queryID,
    objectID,
    timestamp,
  }))

  const updated = [...existing, ...newEntries]

  setInStorage(LOCAL_STORAGE_ALGOLIA_QUERY_INFO, updated, false, true)
}

export const getAlgoliaQueryInfo = (objectID: string): AlgoliaQueryInfo | undefined => {
  return getAllValidQueryInfos().find((info) => info.objectID === objectID)
}

const getAllValidQueryInfos = (): AlgoliaQueryInfo[] => {
  try {
    const now = Date.now()
    const all = getFromStorage<AlgoliaQueryInfo[]>(LOCAL_STORAGE_ALGOLIA_QUERY_INFO, false, true) || []
    const valid = all.filter((info) => now - info.timestamp <= TTL)

    // Cleanup
    if (valid.length !== all.length) {
      setInStorage(LOCAL_STORAGE_ALGOLIA_QUERY_INFO, valid, false, true)
    }

    return valid
  } catch {
    removeFromStorage(LOCAL_STORAGE_ALGOLIA_QUERY_INFO)

    return []
  }
}
